"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const map_event_objects_1 = require("./map-event.objects");
const veflux_1 = require("vasat/dist/src/veflux");
const stream_data_service_1 = require("./stream-data.service");
const environment_1 = require("../../../environments/environment");
const file_data_service_1 = require("./file-data.service");
const core_1 = require("@ngx-translate/core");
//import {ReferenceAnnotation} from '../main/map/photogram/reference-annotation';
class MapDataService {
    constructor(fourD, streams, t, v2FileService) {
        this.fourD = fourD;
        this.streams = streams;
        this.v2FileService = v2FileService;
        this.debug = false;
        // active project and scene
        this._project = new veflux_1.Store(map_event_objects_1.ProjectEvent);
        this._loadingScene = new veflux_1.Store(map_event_objects_1.SceneEvent);
        this._scene = new veflux_1.Store(map_event_objects_1.SceneEvent);
        this._sceneFolder = new veflux_1.Store(file_data_service_1.FolderEvent);
        // active photos and transforms
        this._sceneLayers = new veflux_1.ArrayStore(map_event_objects_1.LayerEvent);
        this._scenePhotos = new veflux_1.ArrayStore(map_event_objects_1.LayerEvent);
        this._sceneJobs = new veflux_1.ArrayStore(map_event_objects_1.JobEvent);
        // project wide annotations
        this._annotations = new veflux_1.ArrayStore(map_event_objects_1.AnnotationEvent).setEqualOperator((a, b) => a.id == b.id);
        // all scenes for project
        this._scenes = new veflux_1.ArrayStore(map_event_objects_1.SceneEvent);
        // displaed annots/layers
        this._displayedLayers = new veflux_1.ArrayStore(map_event_objects_1.LayerEvent, [], this._sceneLayers);
        this._displayedPhotos = new veflux_1.ArrayStore(map_event_objects_1.LayerEvent, [], this._scenePhotos);
        this._displayedAnnotations = new veflux_1.ArrayStore(map_event_objects_1.AnnotationEvent, [], this._annotations);
        this._projectLoading = null;
        this._subs = [];
        this.INVALID_PROJECT = 'Invalid project';
        this.NO_4DSERVICE = '4D Service not initialized';
        t.get('GENERIC.INVALID_PROJECT').subscribe(s => this.INVALID_PROJECT = s);
        t.get('GENERIC.NO_4D').subscribe(s => this.NO_4DSERVICE = s);
        console.log('Hello v2 ' + Math.random());
        if (this.debug && !environment_1.environment.production) {
            this.sceneLayers.events.subscribe(s => console.log('sceneLayers', s));
        }
        this.initSceneListener();
    }
    /** lazy shorthands for listenting to project and scene load events */
    onSceneReady() {
        return this.scene.events.pipe(operators_1.filter(ev => ev.event == 'ADD'), operators_1.take(1));
    }
    onProjectReady() {
        return this.project.events.pipe(operators_1.filter(ev => ev.event == 'ADD'), operators_1.take(1));
    }
    unload() {
        this.v2FileService.refreshWidgets().subscribe();
    }
    /**
     * Updaing the current project using the project ID
     */
    loadProject(pid, sceneId) {
        // if fourD service no initalized, init and try again (note if theres multi accounts this might not work great!)
        if (!this.fourD.projects) {
            return rxjs_1.throwError({ message: this.NO_4DSERVICE });
        }
        var p = this.fourD.projects.find(p => p.id == pid);
        // console.log('map-data.service :: loadProject()', pid, p );
        // project no good    
        if (!p) {
            return rxjs_1.throwError({ message: this.INVALID_PROJECT });
        }
        // project and optionally scene already loaded
        else if (this.project.value == p && (!sceneId || (sceneId && (this.scene.value && this.scene.value.id === sceneId)))) {
            return rxjs_1.of(p);
        }
        // project loaded but scene not correct
        else if (this.project.value == p && sceneId) {
            return this.loadScene(sceneId).pipe(operators_1.map(_ => this.project.value));
        }
        // if this is the first persoin to load the project
        else {
            this.project.value = null;
            this.project.emmit('loading', null, p);
            if (!this._projectLoading)
                this._projectLoading = rxjs_1.forkJoin([
                    // load list of scenes
                    p.groupList(),
                    // load list of annotations (insce theyre currently project specific)
                    this.fourD.V.searchByObject(_4d_mapper_1.Annotation).equals('project', p.id).limit(1001).useCache(true).queryObservable(),
                    // load ACL / widgets access rules
                    this.v2FileService.refreshWidgets(null, p)
                    //this.searchAnnotations(null,p)
                ]).pipe(operators_1.flatMap(([items, annots, w]) => {
                    // wdigets
                    this.v2FileService.acl.addAll(w);
                    // console.log('map-data.service :: loadProject() SCENES', pid );
                    // this will mean all events for scene load fire after this.project is avilable
                    this._scenes.values = items;
                    this.annotations.values = annots.items;
                    //this._annotations.values = (<SearchResults<Annotation>>items[1]).items
                    // done loading the basics, if a scene was specified....
                    if (sceneId) {
                        return this.loadScene(sceneId, p);
                    }
                    else if (this._scenes.values.length) {
                        //will auto load first scene
                        return this.loadScene(this._scenes.values[0].id, p);
                    }
                    else {
                        return rxjs_1.of('');
                    }
                }), operators_1.map(_ => {
                    this._projectLoading = null;
                    this.project.value = p;
                    // console.log('map-data.service :: loadProject() LOADED', pid, p );
                    return p;
                }));
            return this._projectLoading;
        }
    }
    /**
     * Update the scene by loading all of the scenes meta
     * @param tgId
     */
    loadScene(tgId, p = this.project.value) {
        var flyThere = null;
        var found = this.scenes.values.find(s => s.id == tgId);
        if (!found && this.scenes.values.length > 0) {
            return rxjs_1.throwError(new Error("Invalid scene id " + tgId));
        }
        // current scene already loaded
        if (this.scene.value && this.scene.value.id == tgId)
            return rxjs_1.of(this.scene.value);
        // current Scene is loading
        else {
            this.scene.value = null;
            this.loadingScene.value = found;
            // console.log('map-data.service :: loadScene() FORKING', tgId, found );
            rxjs_1.forkJoin([
                // load the layers
                found.children.limit(1002).useCache(true).queryObservable(),
                // load the photos
                found.photos.limit(1003).queryObservable(),
                // scene folder
                found.getSceneFolder(),
            ]).pipe(operators_1.map(([layers, photos, folder]) => {
                // set the asscoiations (do this after setting scene so events fired have access to active Scene)
                this.sceneLayers.values = layers.items;
                this.scenePhotos.values = photos.items;
                this.sceneFolder.value = folder;
                // this.sceneJobs.values = jobs.items
                // console.log('map-data.service :: loadScene() LOADED', tgId );
                this.loadingScene.value = null;
                // set the scene
                this.scene.value = found;
                return found;
            })).subscribe();
            // the observable for this is the first loaded event
            return this.scene.events.pipe(operators_1.filter(e => e.event == 'ADD'), operators_1.map(e => e.item)).take(1);
        }
    }
    /*
    These 2 will need to come back
      private searchAnnotations(complexQuery?: SearchQueryNode,p:Project = this.project.value) {
        var projectQ: SearchQueryNode = {
          op: '=',
          col: 'project',
          val: p.id
        }
    
        return this.fourD.searchFor(Annotation).complexQuery(
          complexQuery ?
            {
              op: 'and',
              items: [projectQ, complexQuery]
            } :
            projectQ
        ).queryObservable().pipe(tap(p => {
          if(this._project.value)
            this.annotations.values = p.items
          
        }))
      }
    
    
      private refreshPhotos(position, applyVerticalOffset: number = 0) {
        
        var query = this.scene.value.photos
    
        if (position)
          query = query.equals('camera', position.latitude + ';' + position.longitude + ';' + (position.height - applyVerticalOffset))
    
        return query.limit(200).queryObservable().pipe(tap(p => {
          this.scenePhotos.values = position ? p.items.sort((a, b) => {
            if (a['selected_position'] && a['selected_position'].x > 0 && (!b['selected_position'] || b['selected_position'].x == -1)) {
              return -10000000000
            }
            else if (b['selected_position'] && b['selected_position'].x > 0 && (!a['selected_position'] || a['selected_position'].x == -1)) {
              return 1000000000
            }
            else if (a['distance'] && b['distance'])
              return a['distance'] - b['distance']
            else
              return 0
          }) : p.items
    
        }))
      }
    */
    /**
     * Remove a transform from a scene
     * @param t
     
    removeFromCurrentScene(t: Transform) {
      return this.scene.children.removeObservable(t).pipe(
        flatMap(_ => {
          this.__sceneLayers = this.sceneLayers.filter(s => s.id != t.id);
          if (this.scene._cachedTransforms) {
            this.scene._cachedTransforms = this.scene._cachedTransforms.filter(tt => tt.id != t.id)
          }
          return this.scene.saveObservable()
        })
      )
    }
  */
    initSceneListener() {
        // if dataset is deleted, and its used in a layer, remove it too
        this._subs.push(this.streams.fileEvents.pipe(operators_1.filter(ev => !!this.sceneLayers.values.find(l => l.id == ev.item['canPlot']))).subscribe(ev => {
            if (ev.event == 'REMOVE') {
                this.sceneLayers.values = this.sceneLayers.values.filter(l => l.id != ev.item['canPlot']);
            }
        }));
        // if dataset is deleted, and its used in a photo, remove it too
        this._subs.push(this.streams.fileEvents.pipe(operators_1.filter(ev => !!this.scenePhotos.values.find(l => l.id == ev.item['canPlot']))).subscribe(ev => {
            if (ev.event == 'REMOVE') {
                this.scenePhotos.values = this.scenePhotos.values.filter(l => l.id != ev.item['canPlot']);
            }
        }));
        // if theres a scene event, update layer or photo
        this._subs.push(this.streams.sceneEvents.pipe(operators_1.filter(ev => ev.item == this.scene.value), operators_1.debounceTime(200)).subscribe(ev => {
            if (ev.event == 'transform_added') {
                this.sceneLayers.set(ev.args.obj);
            }
            if (ev.event == 'photo_added') {
                this.scenePhotos.set(ev.args);
            }
            if (ev.event == 'transform_removed') {
                this.sceneLayers.values = this.sceneLayers.values.filter(t => t.id != ev.args.id);
            }
            if (ev.event == 'photo_removed_all') {
                this.scenePhotos.values = [];
            }
        }));
        // if whole scene is gone
        this._subs.push(this.streams.sceneEvents.pipe(operators_1.filter(ev => ev.item.project == this.project.value), operators_1.debounceTime(200)).subscribe(ev => {
            if (ev.item == this.scene.value) {
                // if ite being removed
                if (ev.event == 'unfetched') {
                    this.scenes.remove(ev.item);
                    if (this.scenes.values.length)
                        this.loadScene(this.scenes.values[0].id).subscribe();
                    else
                        this.clearScene();
                }
                if (ev.event == 'changed') {
                    this.scenes.set(ev.item);
                }
            }
            else if (ev.event == 'fetched') {
                this.scenes.set(ev.item);
            }
        }));
        // annotations
        this._subs.push(this.streams.annotationEvents.pipe(operators_1.filter(ev => ev.item.project == this.project.value), operators_1.debounceTime(200)).subscribe(ev => {
            // if ite being removed
            if (ev.event == 'REMOVE') {
                this.annotations.remove(ev.item);
            }
            else if (ev.event == 'UPDATE' || ev.event == 'ADD') {
                this.annotations.set(ev.item);
            }
        }));
    }
    clearScene() {
        this.scene.value = null;
        this.sceneLayers.values = [];
        this.scenePhotos.values = [];
        this.annotations.values = [];
    }
    clearProject() {
        this.clearScene();
        this.project.value = undefined;
        this._subs.forEach(s => s.unsubscribe());
    }
    // Getters
    get displayedLayers() {
        return this._displayedLayers;
    }
    get displayedAnnotations() {
        return this._displayedAnnotations;
    }
    get displayedPhotos() {
        return this._displayedPhotos;
    }
    get project() {
        return this._project;
    }
    get scene() {
        return this._scene;
    }
    get loadingScene() {
        return this._loadingScene;
    }
    get sceneLayers() {
        return this._sceneLayers;
    }
    get scenePhotos() {
        return this._scenePhotos;
    }
    get scenes() {
        return this._scenes;
    }
    get annotations() {
        return this._annotations;
    }
    get sceneFolder() {
        return this._sceneFolder;
    }
    get sceneJobs() {
        return this._sceneJobs;
    }
}
exports.MapDataService = MapDataService;
